import type { ChatMessageProps } from '../ChatMessage';
import { Stack } from '@workramp/ui';
import { ChatThread } from '../ChatThread/ChatThread';
import { ChatInput } from '../ChatInput/ChatInput';

interface ChatInterfaceProps {
  messages: ChatMessageProps[];
  isSubmitting: boolean;
  emptyState?: React.ReactNode;
  onUserMessage: (message: string) => void;
  onCancel?: () => void;
  placeholder?: string;
  initialValue?: string;
  onChange?: (value: string) => void;
  suggestions?: string[];
}

export const ChatInterface = ({
  messages,
  isSubmitting,
  emptyState,
  onUserMessage,
  onCancel,
  placeholder,
  initialValue,
  onChange,
  suggestions,
}: ChatInterfaceProps) => (
  <Stack size={4}>
    <ChatThread messages={messages} isTyping={isSubmitting} emptyState={emptyState} />
    <ChatInput
      onSubmit={onUserMessage}
      onCancel={onCancel}
      isSubmitting={isSubmitting}
      placeholder={placeholder}
      initialValue={initialValue}
      onChange={onChange}
      suggestions={suggestions}
    />
  </Stack>
);
